import React from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import BannerImg from '../components/BannerImg'
import Work from '../components/Work'

const Project = () => {
    return (
        <>
        <Navbar/>
        <BannerImg 
            heading="PROJECTS."
            text="Some of my most recent works"
        />
        <Work/>
        <Footer/>
       
        </>
    )
}

export default Project
